import { useI18n } from "@/i18n/I18nProvider";


type Institution = {
  id: string;
  name: Record<string, string>;
  href: string;
};

const institutions: Institution[] = [
  { id: "chambre-representants", name: { fr: "Chambre des Représentants", ar: "مجلس النواب", zgh: "ⴰⵙⵇⵇⵉⵎ ⵏ ⵉⵎⵓⵔⴰ" }, href: "https://www.chambredesrepresentants.ma" },
  { id: "chambre-conseillers", name: { fr: "Chambre des Conseillers", ar: "مجلس المستشارين", zgh: "ⴰⵙⵇⵇⵉⵎ ⵏ ⵉⵎⵛⵛⴰⵡⴰⵕⵏ" }, href: "https://www.chambredesconseillers.ma" },
  { id: "chef-gouvernement", name: { fr: "Chef du Gouvernement", ar: "رئيس الحكومة", zgh: "ⴰⵏⵙⵙⵉⵅⴼ ⵏ ⵜⵏⴱⴰⴹⵜ" }, href: "https://www.cg.gov.ma" },
  { id: "cour-constitutionnelle", name: { fr: "Cour Constitutionnelle", ar: "المحكمة الدستورية", zgh: "ⵜⴰⵙⵏⴱⴰⴹⵜ ⵜⴰⴷⵓⵙⵜⵓⵔⴰⵏⵜ" }, href: "https://www.cour-constitutionnelle.ma" },
  { id: "sgg", name: { fr: "Secrétariat Général du Gouvernement", ar: "الأمانة العامة للحكومة", zgh: "ⵜⴰⵏⴼⵍⵓⵙⵜ ⵜⴰⵎⴰⵜⴰⵢⵜ ⵏ ⵜⵏⴱⴰⴹⵜ" }, href: "https://www.sgg.gov.ma" },
  { id: "cspj", name: { fr: "Conseil Supérieur du Pouvoir Judiciaire", ar: "المجلس الأعلى للسلطة القضائية", zgh: "ⴰⵙⵇⵇⵉⵎ ⴰⵏⴰⴼⵍⵍⴰ ⵏ ⵜⵏⴱⴰⴹⵜ ⵜⴰⵣⵔⴼⴰⵏⵜ" }, href: "https://www.cspj.ma" },
  { id: "cour-comptes", name: { fr: "Cour des Comptes", ar: "المجلس الأعلى للحسابات", zgh: "ⵜⴰⵙⵏⴱⴰⴹⵜ ⵏ ⵉⵎⵉⴹⴰⵏⵏ" }, href: "https://www.courdescomptes.ma" },
  { id: "cndh", name: { fr: "Conseil National des Droits de l'Homme", ar: "المجلس الوطني لحقوق الإنسان", zgh: "CNDH" }, href: "https://www.cndh.org.ma" },
  { id: "mediateur", name: { fr: "Institution du Médiateur", ar: "مؤسسة الوسيط", zgh: "ⴰⵎⵙⴳⴳⵉⵡⵙ" }, href: "https://www.mediateur.ma" },
  { id: "cese", name: { fr: "Conseil Économique, Social et Environnemental", ar: "المجلس الاقتصادي والاجتماعي والبيئي", zgh: "CESE" }, href: "https://www.cese.ma" },
  { id: "haca", name: { fr: "HACA (Audiovisuel)", ar: "الهاكا (الاتصال السمعي البصري)", zgh: "HACA" }, href: "https://www.haca.ma" },
  { id: "inpplc", name: { fr: "INPPLC (Lutte contre la corruption)", ar: "الهيئة الوطنية للنزاهة والوقاية من الرشوة", zgh: "INPPLC" }, href: "https://www.inpplc.ma" },
  { id: "oulema", name: { fr: "Conseil Supérieur des Ouléma", ar: "المجلس العلمي الأعلى", zgh: "ⴰⵙⵇⵇⵉⵎ ⴰⵏⴰⴼⵍⵍⴰ ⵏ ⵉⵎⴰⵙⵙⴰⵏⵏ" }, href: "https://www.aloulamas.ma" },
  { id: "ccme", name: { fr: "CCME (Marocains à l'étranger)", ar: "مجلس الجالية المغربية بالخارج", zgh: "CCME" }, href: "https://www.ccme.org.ma" },
];

const InstitutionsBar = () => {
  const { lang } = useI18n();

  const sectionLabel = {
    fr: "Institutions constitutionnelles",
    ar: "المؤسسات الدستورية",
    zgh: "ⵜⵉⵎⵔⵙⴰⵍ ⵜⵉⴷⵓⵙⵜⵓⵔⴰⵏⵉⵏ",
  };

  return (
    <section id="institutions" className="py-4 md:py-6 bg-card border-b border-border">
      <div className="container px-3 md:px-6">
        <h2 className="text-center font-display font-extrabold text-lg md:text-2xl text-foreground mb-4 md:mb-6">
          {sectionLabel[lang]}
        </h2>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {institutions.map(inst => (
            <a
              key={inst.id}
              href={inst.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-2.5 py-2 md:px-4 md:py-2.5 rounded-xl bg-background border border-border text-xs md:text-sm font-body font-semibold text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-200 shadow-card hover:shadow-elevated"
            >
              <span className="line-clamp-1">{inst.name[lang] || inst.name.fr}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstitutionsBar;
